import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Radium } from 'higher-order-components'
import { InlineDisclaimerBlock } from 'containers'
import { WysiwygContent } from 'components'
import { H6, Space } from 'AtomicComponents'
/** Specification List Component */
class SpecificationListItem extends Component {
  static propTypes = {
    name: PropTypes.string,
    items: PropTypes.array
  }

  /**
   * @returns {ReactElement} React Component
   */
  render() {
    const { name, items, gtmEventsDisclaimers, imageUrl, description, partNumber } = this.props

    return (
      <div style={styles.content}>
        {imageUrl && <div><img src={imageUrl} style={styles.img} alt="" /></div>}
        <div style={styles.contentCell}>
          {name && <H6 withDetails style={styles.subLabel}>{name}</H6>}
          {name && <Space />}
          {description && <WysiwygContent xmlString={description} />}
          {partNumber && <WysiwygContent xmlString={`<p>PART NUMBER: ${partNumber}</p>`} style={styles.contentText} />}
        </div>
        {items && (
          <div style={styles.contentCell}>
            {items.map((item, index) => (
              <div key={index}>
                <div style={styles.item}>
                  <InlineDisclaimerBlock
                    yOffset={-6}
                    showingUnderline
                    gtmEvents={gtmEventsDisclaimers}
                    identifier={item.disclaimer && item.disclaimer.disclaimerCode}
                    message={item.disclaimer && item.disclaimer.disclaimerText}>
                    {item.key}
                    {item.content && <span style={styles.contentText}> {item.content}</span>}
                  </InlineDisclaimerBlock>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default Radium(SpecificationListItem)

const styles = {
  subLabel: {
    fontSize: '81%',
    textTransform: 'uppercase',
    letterSpacing: '.2em',
    marginBottom: '1em',
    fontWeight: 600
  },
  item: {
    display: 'inline-block',
    fontWeight: 200,
    fontSize: '100%',
    margin: '0 0 1em',
    lineHeight: '1.2'
  },
  content: {
    display: 'flex',
    padding: '1em 0px',
    flexWrap: 'wrap',
    '@media (min-width: 768px)': {
      padding: '2em 0px'
    }
  },
  contentCell: {
    flex: '1 1 100%',
    '@media (min-width: 768px)': {
      flex: '1 1 50%'
    }
  },
  img: {
    marginRight: '2em',
    width: '230px'
  },
  contentText: {
    color: '#888'
  }
}



// WEBPACK FOOTER //
// ./src/containers/specification-list-item/index.jsx